var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4945",
    d: "M4.41992 8.8621H7.84029C7.84029 8.8621 6.1301 7.90751 6.1301 4.56643C6.1301 1.22535 6.55266 0.726588 6.55266 0.726588L4.41992 0.722656",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4946",
    d: "M4.41992 8.8626H0.999558C0.999558 8.8626 2.70974 7.90802 2.70974 4.56694C2.70974 1.22586 2.35011 0.722656 2.35011 0.722656L4.41992 0.722882",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M4.42188 8.8623V13.2773",
    stroke: "#825DFC",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 300",
    d: "M1.5 8.72266C3.1 7.92266 2.83333 3.38932 2.5 1.22266L6.5 0.722656C5.3 4.32266 6.66667 7.55599 7.5 8.72266H1.5Z",
    fill: "#825DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinned);
export default __webpack_public_path__ + "static/media/Icon_pinned.52acc77de08228b0f2ca4929a8e44df3.svg";
export { ForwardRef as ReactComponent };